import type {ElementData} from '@Libraries/add-media-library';
import type {BasePanel} from '@Components/panel/panel.types';

export interface AiImagePanelProps extends BasePanel {
  className?: string;
  gridID?: string;
  selectionID?: string;
  populateRecentlyAddedOnItemAdd?: boolean;
  shouldLoadDataUrlImage?: boolean;
  onAddSelected(items: Array<ElementData>): void;
  onClose?(): void;
}

export enum AiImagePanelState {
  GENERATION,
  STYLE_PRESET,
  ASPECT_RATIO_PRESET,
}
